import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=c9779dc8&scoped=true"
import script from "./CardImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=c9779dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9779dc8",
  null
  
)

export default component.exports